import { Variants } from "framer-motion";
import { Task01Icon, Calendar01Icon } from "@hugeicons/core-free-icons";
import { HugeIconData, IconAnimationPreset } from "./AnimatedIcon";

const ease = [0.4, 0, 0.2, 1] as const;
const idle: Variants = { rest: {}, hover: {} };

// Task01Icon paths: [0] the clip, [1] the checklist lines, [2] the board
// outline. The clip lifts and tilts like it's about to tick something off.
//
// No itshover equivalent exists for this or Calendar01Icon below (its
// closest names - "checked", "unordered-list" - don't read as "task/goal"),
// so these two keep the hand-built multi-path treatment instead of forcing
// an unrelated icon in just to reuse the library.
const taskPreset: IconAnimationPreset = {
    parts: {
        0: {
            rest: { y: 0, rotate: 0 },
            hover: { y: -1.2, rotate: -5, transition: { duration: 0.3, ease } },
        },
    },
    defaultPart: idle,
};

// Calendar01Icon paths: [0] the two hanging binder rings - they swing down a
// touch on hover, like the page underneath just flipped.
const calendarPreset: IconAnimationPreset = {
    parts: {
        0: {
            rest: { y: 0 },
            hover: { y: 1.3, transition: { duration: 0.3, ease } },
        },
    },
    defaultPart: idle,
};

/** Icon data array reference -> its bespoke hover preset. */
export const ICON_ANIMATION_PRESETS = new Map<HugeIconData, IconAnimationPreset>([
    [Task01Icon as unknown as HugeIconData, taskPreset],
    [Calendar01Icon as unknown as HugeIconData, calendarPreset],
]);
